import {
  Box,
  FormControlLabel,
  FormHelperText,
  Checkbox as MuiCheckbox,
  Tooltip,
} from "@mui/material";
import { useField } from "formik";
import { ReactNode } from "react";

type CheckboxProps = {
  name: string;
  dataT1?: string;
  tooltipMessage?: string;
  children?: ReactNode;
};

const CheckboxMUI = ({
  name,
  dataT1 = "checkbox",
  tooltipMessage = "",
  children,
}: CheckboxProps) => {
  const [field, meta] = useField(name);
  const isError = meta.touched && Boolean(meta.error);

  const checkbox = (
    <MuiCheckbox
      {...field}
      data-t1={dataT1}
      checked={field.value}
      sx={{
        alignSelf: "flex-start",
        ...(isError && {
          color: "error.main",
          "&.Mui-checked": {
            color: "error.main",
          },
          "&:hover": {
            backgroundColor: "rgba(211, 47, 47, 0.04)",
          },
        }),
      }}
    />
  );

  return (
    <Box>
      <FormControlLabel
        control={
          tooltipMessage ? (
            <Tooltip title={tooltipMessage} placement="top" arrow>
              {checkbox}
            </Tooltip>
          ) : (
            checkbox
          )
        }
        label={children}
        sx={{ mb: 0 }}
      />
      {isError && <FormHelperText error>{meta.error}</FormHelperText>}
    </Box>
  );
};

export default CheckboxMUI;
